import { YearData } from "constant/Years";
import { useState } from "react";

function YearSelector({ selectedYear, setSelectedYear }: any) {
  const [years] = useState<any>(YearData);

  const onChange = (e: any) => {
    setSelectedYear(e.target.value);
  };

  return (
    <div className="flex items-center gap-2 max-sm:ml-2 max-sm:w-full max-sm:pr-4">
      <label htmlFor="cars" className="text-sm text-white/60 max-md:hidden">
        Years
      </label>
      <div className="relative max-sm:w-full">
        <select
          name="cars"
          id="cars"
          className="cursor-pointer appearance-none rounded-full border border-white/15 bg-white/5 py-2 pl-4 pr-10 text-sm text-white outline-none transition-colors hover:border-white/30 focus:border-white/40 max-sm:w-full"
          onChange={onChange}
          value={selectedYear}
        >
          <option value={""} className="bg-[#1a1a1d] text-white">
            All
          </option>
          {years &&
            years?.map((c: any, i: number) => (
              <option value={c.year} key={i} className="bg-[#1a1a1d] text-white">
                {c.year}
              </option>
            ))}
        </select>
        {/* chevron */}
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-white/50">
          <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </div>
    </div>
  );
}

export default YearSelector;